import React from 'react';
import './styles.less';

export const CustomRequiredComponent = () => {
	return <span className="custom-required">*</span>;
};
